import { all } from 'redux-saga/effects';
import { combineReducers } from 'redux';
import storeConfig from './storeConfig';

import { reducer as apiLoopStateReducer } from './modules/apiLoopState';
import { reducer as notificationReducer } from './modules/notification';

import {
  reducer as authReducer,
  saga as authSaga,
} from './modules/auth';

import {
  reducer as storeReducer,
  saga as storeSaga,
} from './modules/store';

export default () => {
  const appReducer = combineReducers({
    auth: authReducer,
    apiLoopState: apiLoopStateReducer,
    store: storeReducer,
    notification: notificationReducer,
  });

  return storeConfig(appReducer, function* rootSaga() {
    yield all([authSaga(), storeSaga()]);
  });
};
